import {InjectionToken} from '@angular/core';
import type {Observable} from 'rxjs';
import type {ContactEvent} from '../types/contacts.types';

export interface UserEventsApi {
  listEvents(needUsedCount?: boolean): Observable<ContactEvent[]>;
  createEvent(name: string): Observable<ContactEvent>;
  updateEvent(id: string, name: string): Observable<void>;
  deleteEvent(id: string): Observable<void>;
}

export const USER_EVENTS_API = new InjectionToken<UserEventsApi>('USER_EVENTS_API');
